<mat-card appearance="outlined" class="card-primary" [style.padding]="'0'">
  @if (closeButton) {
    <button mat-icon-button class="close-button" [mat-dialog-close]="false">
      <mat-icon>clear</mat-icon>
    </button>
  }
  @if (this.data.dataRegistration) {
    <div class="registration-component">
      @if (!isActive) {
        <p class="content-deleted">
          {{ 'case.tasks.content-deleted' | translate | capitalize }}
        </p>
      }
      @if (this.functionType !== 'careplan-nnn') {
        <app-form-wrapper
          [formId]="this.data.form.id"
          [registrations]="[this.data.dataRegistration]"
          [preview]="true"></app-form-wrapper>
      }
      @if (this.functionType === 'careplan') {
        <app-careplan-registration-row-table
          [columnHeaders]="columns"
          [activeRegistration]="data.dataRegistration"
          [editOptions]="false"></app-careplan-registration-row-table>
      }
      @if (this.functionType === 'careplan-nnn') {
        <app-nnn-registration-preview
          class="nnn-preview"
          [class.nnn-preview--below-close-button]="closeButton"
          [patientId]="patientId"
          [registrationId]="data.dataRegistration.id"
          [careInstitutionId]="careInstitutionId"></app-nnn-registration-preview>
      }
    </div>
  }
</mat-card>
